import React, { useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { checkFilterItem, fetchFilterData } from "../../../../utils/fetchFilterData";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import Notification from "../../../elements/notification/Notification";
import TelegramConnectionsList from "./TelegramConnectionsList";
import TelegramConnectionsFilter from "./TelegramConnectionsFilter";
import FilterAppliedList from "../../../elements/filter/FilterAppliedList";
import TelegramAddConnectionDialog from "./TelegramAddConnectionDialog";
import TelegramEditConnectionDialog from "./TelegramEditConnectionDialog";
import DialogModal from "../../../elements/dialogModal/DialogModal";

const TelegramConnectionsContainer = () => {
  const { t } = useTranslation("telegramBotPage");
  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "currentTab": checkFilterItem(history, "currentTab", "connections", false, true),
    "projectId": checkFilterItem(history, "projectId", null),
  });

  const [bots, setBots] = useState([]);
  const [botsLoading, setBotsLoading] = useState(false);
  const [connections, setConnections] = useState(null);
  const [editConn, setEditConn] = useState(null);
  const [openEdit, setOpenEdit] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);
  const [notification, setNotification] = useState({ visible: false, type: "", message: "" });

  const fetchBots = () => {
    if (botsLoading) return;
    setBotsLoading(true);
    axios.get("/api/telegram/bots", userAuthenticationConfig()).then(response => setBots(response.data || [])).catch(() => setBots([])).finally(() => setBotsLoading(false));
  };

  const fetchConnections = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);
    setConnections(null);
    axios.get("/api/telegram/connections" + filterUrl, userAuthenticationConfig()).then(r => setConnections(r.data["hydra:member"] || [])).catch(error => {
      setNotification({
        visible: true,
        type: "error",
        message: error?.response?.data?.message || t("connections.errors.load")
      });
      setConnections([]);
    });
  };

  useEffect(() => {
    fetchConnections();
  }, [filterData]);

  const handleDeleteConnection = () => {
    axios.delete(`/api/telegram/project-connections/${deleteId}`, userAuthenticationConfig())
      .then(r => {
        if (r.status === 204) {
          setOpenDelete(false);
          setNotification({ visible: true, type: "success", message: t("connections.success.deleted") });
          fetchConnections();
        }
      })
      .catch(error => {
        setNotification({ visible: true, type: "error", message: error?.response?.data?.message || t("connections.errors.delete") });
      });
  };

  return (
    <>
      <Notification notification={notification} setNotification={setNotification} />
      <div className="content-head" style={{ justifyContent: "space-between" }}>
        <TelegramConnectionsFilter
          filterData={filterData}
          setFilterData={setFilterData}
          bots={bots}
          botsLoading={botsLoading}
          onOpen={fetchBots}
          t={t}
        />
        <TelegramAddConnectionDialog
          setNotification={setNotification}
          onAdded={fetchConnections}
          t={t}
        />
      </div>
      <FilterAppliedList
        filterData={filterData}
        setFilterData={setFilterData}
      />
      <TelegramConnectionsList
        connections={connections}
        onEdit={(conn) => {
          setEditConn(conn);
          setOpenEdit(true);
        }}
        onDelete={(id) => {
          setDeleteId(id);
          setOpenDelete(true);
        }}
        t={t}
      />
      {editConn && (
        <TelegramEditConnectionDialog
          open={openEdit}
          onClose={() => setOpenEdit(false)}
          conn={editConn}
          setNotification={setNotification}
          onSaved={fetchConnections}
          t={t}
        />
      )}
      <DialogModal
        open={openDelete}
        setOpen={setOpenDelete}
        title={t("connections.dialog.deleteTitle")}
        content={t("connections.dialog.deleteText")}
        cancelButton={t("connections.dialog.cancel")}
        approveButton={t("connections.dialog.delete")}
        onApprove={handleDeleteConnection}
      />
    </>
  );
};

export default TelegramConnectionsContainer;
